import StepOneIcon from './component.jsx'
export default StepOneIcon
